angular.module('app.api').factory('UserServiceApi', [
  'api',
  function UserServiceApi(api) {
    const userServiceApi = {
      getUser: async userId => {
        return api.get(`users/${userId}`)
      },
      getUserAssignedAgent: async userId => {
        return api.get(`users/${userId}/agent`)
      },
    }
    return userServiceApi
  },
])



// WEBPACK FOOTER //
// ./scripts/shared/services/user-service.api.js